<template>
  <div class="auth-input-wrapper">
    <input :class="{ error: !isValid,
          valid: isValid && value.length > 0 && active}"
      @input="validateWithDebounce"
      @blur="validate"
      @focus="activate"
      v-model="value"
      type="password"
      id="repeat-password"
      required
    >
    <label for="repeat-password">Powtórz hasło</label>
    <p class="error" v-if="!isValid">Hasła nie są identyczne!</p>
  </div>
</template>

<script>
import { validateMatch, debounce, debounceOffset } from '../authValidation';

export default {
  name: 'RepeatPasswordAuthInput',
  data() {
    return {
      active: false
    };
  },
  computed: {
    value: {
      get() {
        return this.$store.getters.registrationRepeatPassword;
      },
      set(value) {
        this.$store.commit('updateRegistrationRepeatPassword', value);
      }
    },
    password() {
      return this.$store.getters.registrationPassword;
    },
    isValid() {
      return this.$store.getters.isRegistrationPasswordMatch;
    }
  },
  methods: {
    activate() {
      this.active = true;
    },
    validateWithDebounce(e) {
      this.$store.dispatch('clearAllAuthErrors');
      debounce(() => {
        this.validate(e);
      }, debounceOffset);
    },
    validate() {
      this.$store.commit('updateIsRegistrationPasswordMatch',
        validateMatch(this.password, this.value));
    }
  }
};
</script>
